module.exports = __webpack_public_path__ + "static/sutter-health-1-3565127ddfdf0cfa6ef46e3212c37ccf.png";